export function getViewPortClickPosition(canvas : SVGSVGElement, event : React.MouseEvent | MouseEvent) : [number, number] {
  let point = canvas.createSVGPoint();
  point.x = event.clientX;
  point.y = event.clientY;

  let transformation = point.matrixTransform(canvas.getScreenCTM()!.inverse());

  return [transformation.x, transformation.y];
}